import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/SpectusHRMS.png";
import LoginStyle from "./LoginStyle";
import { Row, Col, Form, Input, Image } from "antd";
import "./index.css";
import { getFirestore } from "firebase/firestore";
import { collection, query, where, getDocs } from "firebase/firestore";
import {
  Box,
  Button,
  Card,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { toast } from "react-toastify";
import env from "../../config/env";
import CryptoJS from 'crypto-js';
import { setToken, setUserData } from "../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';

export const userLoginCredentials = {};

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

const Login = () => {
  const [emailerror, setemailerror] = useState("");
  const [passworderror, setPassworderror] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });
  const passwordRef = useRef(null);
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const encryptNumber = (number, key) => {
    const encrypted = CryptoJS.AES.encrypt(number.toString(), key).toString();
    return encrypted;
  };
  const formSubmit = async () => {
    const email = inputData.email;
    const password = inputData.password;

    if (email === "" || email === undefined) {
      setemailerror("Please input your email!");
    }
    if (password === "" || password === undefined) {
      setPassworderror("Please input your password!");
    }
    if (
      email === "" ||
      password === "" ||
      email === undefined ||
      password === undefined
    ) {
      return;
    }
    if (!email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      setemailerror("Please, Enter Valid Email Address");
      return;
    }

    try {

      const data = { email: email, userpassword: password, };

      const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();

      const login = CryptoJS.SHA256("/login" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(`${env.backend_api_endpoint}/${login}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ encryptedData: encryptedBody }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 404) {
          setemailerror("Please, Enter Valid Email Address");
        }
        if (errorData.status === 400) {
          setPassworderror("Please, Enter Valid Password");
        }
        if (errorData.status === 403) {
          toast.error(errorData.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
        }
        if (errorData.status === 405) {
          toast.error(errorData.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
        }
      }
      if (response.ok) {
        const successData = await response.json();

        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          setPassworderror("");
          setemailerror("");
          dispatch(setToken(decryptedData.token));
          dispatch(setUserData(decryptedData.userData));
          toast.success("Login Successfully !", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate(`/`);
        }
      }
    } catch (error) {
      console.error("Error Login in:", error.message);
    }
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <LoginStyle>
      {/* <div className="mainLoginDiv">
        <div className="img_div">
          <Image src={Logo} preview={false}></Image>
        </div>
        <div className="form_card">
          <h3
            style={{
              fontSize: "36px",
              fontWeight: "600",
              color: "#244DA0",
              fontStyle: "normal",
              textAlign: "left",
              padding: "22px",
              fontFamily: "ImportedMilliardBold",
            }}
          >
            Sign In
          </h3>
          <div className="form_item">
            <Typography className="label_form">Email address </Typography>
            <TextField
              placeholder="Email address"
              onKeyDown={(e) => {
                let space = 32;
                if (e.keyCode === space) {
                  e.preventDefault();
                }
                if (e.key === "Enter") {
                  passwordRef.current.focus();
                }
              }}
              onChange={(e) => {
                setemailerror("");
                if (e.target.value === "") {
                  setemailerror("Please input your email!");
                } else {
                  setInputData({ ...inputData, email: e.target.value });
                  setemailerror("");
                }
              }}
              autoComplete="off"
              size="medium"
              error={emailerror === "" ? false : true}
              helperText={emailerror}
            />

            <Typography className="label_form" style={{ marginTop: "10px" }}>
              Password{" "}
            </Typography>
            <OutlinedInput
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setPassworderror("");
                setInputData({ ...inputData, password: e.target.value });
                if (e.target.value === "") {
                  setPassworderror("Please input your Password!");
                } else {
                  setPassworderror("");
                }
                return true;
              }}
              inputRef={passwordRef}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  formSubmit();
                }
              }}
              size="medium"
              autoComplete="off"
              error={passworderror === "" ? false : true}
            />
            <FormHelperText id="helper_text">{passworderror}</FormHelperText>
            <div
              style={{
                color: "#4CA299",
                fontWeight: "500",
                fontSize: "18px",
                textAlign: "end",
                fontFamily: "Milliard",
                marginBottom: "25px",
                marginTop: "0px",
              }}
            >
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
            <Button
              variant="contained"
              onClick={formSubmit}
              style={{
                background: "#244DA0",
                borderRadius: "6px",
                marginTop: "70px",
                marginBottom: "20px",
                fontFamily: "ImportedMilliardBold",
                fontSize: "18px",
                // padding: "1px",
                height: "46px",
                textTransform: "none",
              }}
            >
              Sign In
            </Button>
          </div>
        </div>
      </div> */}
      <Box className="bg-container">
        <Box className="content-center">
          <Box className="login-container">
            <Box className="content-center" mb={3}>
              <img src={Logo} alt='logo' width="250px" height="auto" />
            </Box>

            <Card variant="outlined" sx={{ padding: 3 }}>
              <Box>
                <Typography variant='h5' sx={{ mb: 3, fontFamily: "ImportedMilliardBold", color: '#244DA0' }}>
                  Sign In
                </Typography>
              </Box>
              <Box>
                <Box sx={{ mb: 3 }}>
                  <Typography variant="body1" gutterBottom className='login-form-label label_form'>
                    Email
                  </Typography>
                  <TextField
                    placeholder="Email address"
                    onKeyDown={(e) => {
                      let space = 32;
                      if (e.keyCode === space) {
                        e.preventDefault();
                      }
                      if (e.key === "Enter") {
                        passwordRef.current.focus();
                      }
                    }}
                    onChange={(e) => {
                      setemailerror("");
                      if (e.target.value === "") {
                        setemailerror("Please input your email!");
                      } else {
                        setInputData({ ...inputData, email: e.target.value });
                        setemailerror("");
                      }
                    }}
                    autoComplete="off"
                    size="medium"
                    error={emailerror === "" ? false : true}
                    helperText={emailerror}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <i class="fa-regular fa-envelope" style={{ color: "#244DA0", width: "16px", }}></i>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        padding: '10px 12px', // Adjust padding inside the input
                      },
                      width: '100%'
                    }}
                  />
                </Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body1" gutterBottom className='login-form-label label_form'>
                    Password
                  </Typography>
                  <OutlinedInput
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    onChange={(e) => {
                      setPassworderror("");
                      setInputData({ ...inputData, password: e.target.value });
                      if (e.target.value === "") {
                        setPassworderror("Please input your Password!");
                      } else {
                        setPassworderror("");
                      }
                      return true;
                    }}
                    inputRef={passwordRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        formSubmit();
                      }
                    }}
                    size="medium"
                    autoComplete="off"
                    error={passworderror === "" ? false : true}
                    sx={{
                      '& .MuiInputBase-input': {
                        padding: '10px 12px', // Adjust padding inside the input
                      },
                      width: '100%'
                    }}
                  />
                  <FormHelperText id="helper_text">{passworderror}</FormHelperText>
                </Box>

                <Box
                  sx={{
                    color: "#4CA299",
                    fontWeight: "500",
                    fontSize: "18px",
                    textAlign: "end",
                    fontFamily: "Milliard",
                    marginBottom: "25px",
                    marginTop: "0px",
                  }}
                >
                  <Link to="/forgot-password">Forgot Password?</Link>
                </Box>
                <Button
                  variant="contained"
                  onClick={formSubmit}
                  style={{
                    background: "#244DA0",
                    borderRadius: "6px",
                    // marginTop: "70px",
                    marginBottom: "20px",
                    fontFamily: "ImportedMilliardBold",
                    fontSize: "18px",
                    // padding: "1px",
                    height: "46px",
                    textTransform: "none",
                    width: '100%'
                  }}
                >
                  Sign In
                </Button>
              </Box>
            </Card>
          </Box>
        </Box>
      </Box>
    </LoginStyle>
  );
};

export default Login;
